<div class="flex-1 bg-gray-50 flex flex-col min-h-full">
  <!-- Main Content -->
  <main
    class="max-w-7xl mx-auto py-4 sm:px-6 lg:px-8 flex-1 flex flex-col gap-y-4"
  >
    <!-- Welcome Message -->
    <div class="fade-in flex flex-col gap-y-1">
      <h1 class="text-2xl font-semibold text-gray-900">
        Welcome {{ authStore.userFullName() }}!
      </h1>
      @if (authStore.currentCompany()) {
      <span class="text-gray-700 text-sm"
        >You are logged into <b>{{ authStore.currentCompany()?.name }}</b>
      </span>
      }
    </div>

    <!-- Stats Cards -->
    @if (canViewStats()) {
    <div class="fade-in fade-in-delay-2">
      <lib-stats-section [statsState]="statsState()" />
    </div>
    }

    <!-- Pending Referral Tasks -->
    @if (canViewPendingTasks()) {
    <div class="fade-in fade-in-delay-2">
      <lib-pending-referral-tasks-section
        [needsAcceptanceTasks]="needsRefereeAcceptanceTasks()"
        [waitingOnRefereeTasks]="waitingOnRefereeTasks()"
        [commissionDueTasks]="commissionDueTasks()"
        [loading]="
          pendingReferralTasksLoading() || pendingCommissionTasksLoading()
        "
        [error]="pendingReferralTasksError()"
      />
    </div>
    }

    <!-- Quick Actions -->
    @if (canViewQuickActions()) {
    <div class="fade-in fade-in-delay-3">
      <lib-quick-actions-section />
    </div>
    }
  </main>
</div>
